<template>
  <div :class="classObj" class="app-wrapper">
    <div v-if="device === 'mobile' && sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <!-- 吸顶 -->
    <div class="header">
      <div class="system-info">
        <img src="../assets/image/CDClogo.png" class="sidebar-logo">
        {{ title }}
      </div>
      <div class="user-meta">
        <el-dropdown trigger="click">
          <div class="user-info">
            <span class="el-dropdown-link user-name">
              <template v-if="orgName">
                <span class="org-name">{{ orgName }}</span>
                <span class="name-separator">|</span>
              </template>
              <span class="user-name-text">{{ userName }}</span>
              <i class="el-icon-arrow-down el-icon--right" />
            </span>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="handlePersonalCenter">个人中心</el-dropdown-item>
            <el-dropdown-item @click.native="editPassWord">修改密码</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="user-info" @click="drawer = true">
          <span class="user-name el-dropdown-link"> <i class="el-icon-tickets" />
            备忘录</span>
        </div>

        <!-- <div class="user-info">
          <span class="user-name">{{ userName }}</span>
        </div> -->

        <div class="meta-divider" />
        <!-- <div class="logout" @click="editPassWord">
          <i class="el-icon-edit-outline" />
          修改密码
        </div> -->
        <div class="meta-divider" />
        <div class="logout" @click="logout">
          <i class="el-icon-switch-button" />
          退出
        </div>
        <div class="meta-divider" />
        <div class="logout" @click="changeSys">
          <i class="el-icon-refresh" />
          切换系统
        </div>
      </div>
    </div>
    <sidebar class="sidebar-container" style="margin-top:48px;" />
    <el-dialog title="修改密码" :visible.sync="pwdUse" width="55%" center>
      <el-form ref="formData" :model="formData" :rules="rules" label-width="50%" class="mb15">
        <el-row type="flex" justify="start">
          <el-col :span="18">
            <el-form-item label="原密码" prop="userPwd">
              <el-input v-model="formData.userPwd" width="50%" placeholder="请输入原密码" show-password auto-complete="new-password" maxlength="100" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start" style="margin: 13px 0">
          <el-col :span="18">
            <el-form-item label="新密码" prop="nwUserPwd">
              <el-input v-model="formData.nwUserPwd" width="50%" placeholder="请输入新密码" show-password auto-complete="new-password" maxlength="100" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start">
          <el-col :span="18">
            <el-form-item label="新密码" prop="qrNewUserPwd">
              <el-input v-model="formData.qrNewUserPwd" width="50%" placeholder="请确认新密码" show-password auto-complete="new-password" maxlength="100" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="pwdUseClose">取 消</el-button>
        <el-button type="primary" @click="submitPwdFun('formData')">确 定</el-button>
      </span>
    </el-dialog>
    <div :class="{ hasTagsView: needTagsView }" class="main-container">
      <div class="fixed-header">
        <navbar />
        <tags-view v-if="needTagsView" />
      </div>
      <app-main />
      <!--  <right-panel v-if="showSettings">
        <settings />
      </right-panel> -->
    </div>
    <el-drawer
      title="备忘录"
      width="35%"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <MyComPonent />
    </el-drawer>
  </div>
</template>

<script>
import { AppMain, Navbar, Sidebar, TagsView } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import { mapState } from 'vuex'
import { updatePwd } from '../api/sso/user.js'
import setting from '@/settings'
import md5 from 'md5'
import MyComPonent from '../components/memorandum/index.vue'

export default {
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    Sidebar,
    TagsView,
    MyComPonent
  },
  mixins: [ResizeMixin],
  data() {
    const validPassWord = (rule, value, callback) => {
      const reg = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#%*])[a-zA-Z0-9!@*%#]{8,16}$/
      if (!reg.test(value)) {
        callback(new Error('密码必须是由8-16的英文(大写+小写)、数字、特殊符号(!、@、#、%、*)组合'))
      } else {
        callback()
      }
      callback()
    }
    const checkOne = (rule, value, callback) => {
      const reg = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#%*])[a-zA-Z0-9!@*%#]{8,16}$/
      if (!reg.test(value)) {
        callback(new Error('密码必须是由8-16的英文(大写+小写)、数字、特殊符号(!、@、#、%、*)组合'))
      } else if (this.formData.nwUserPwd !== value) {
        callback(new Error('请确认两次输入密码一致'))
      } else {
        callback()
      }
      callback()
    }
    return {
      rules: {
        userPwd: [
          { required: true, message: '请填写原密码', trigger: 'blur' }
        ],
        nwUserPwd: [
          { required: true, message: '请填写新密码', trigger: 'blur' },
          { validator: validPassWord, message: '密码必须是由8-16的英文(大写+小写)、数字、特殊符号(!、@、#、%、*)组合', trigger: 'blur' }
        ],
        qrNewUserPwd: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { validator: checkOne, message: '', trigger: 'blur' }
        ]
      },
      drawer: false,
      // getAreaId: getAreaId(),
      title: '',
      userName: '',
      orgName: '',
      drugData: false,
      monitorData: false,
      indexPath: process.env.VUE_APP_INDEX,
      loginPath: process.env.VUE_APP_LOGIN,
      pwdUse: false,
      formData: {
        userPwd: '',
        newUserPwd: ''
      }
    }
  },
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      showSettings: state => state.settings.showSettings,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => state.settings.fixedHeader
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  mounted() {
    this.userName = this.$store.state.user.user.realName
    this.orgName = this.$store.state.user.user.userOrgName
    let pathSub = this.$route.path.substring(1)
    let systemType = ''
    if (pathSub.startsWith('baseInfo') || pathSub.startsWith('system') || pathSub.startsWith('base')) {
      systemType = 'base'
    } else {
      if (pathSub.includes('/')) {
        pathSub = pathSub.substring(0, pathSub.indexOf('/'))
        systemType = pathSub
      } else {
        systemType = pathSub
      }
    }
    console.info('systemType', systemType)
    if (systemType === 'base') {
      this.title = setting.base_title
    } else if (systemType === 'lab') {
      this.title = setting.lab_title
    } else if (systemType === 'oa') {
      this.title = setting.oa_title
    } else if (systemType === 'hr') {
      this.title = setting.hr_title
    } else if (systemType === 'stock') {
      this.title = setting.stock_title
    } else if (systemType === 'budget') {
      this.title = setting.budget_title
    } else if (systemType === 'adm') {
      this.title = setting.adm_title
    } else if (systemType === 'purchase') {
      this.title = setting.purchase_title
    } else {
      this.title = setting.title
    }
    // this.title = setting.title
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    },
    async logout() {
      const isPlaaa = process.env.VUE_APP_IS_PL
      const baseLogin = process.env.VUE_APP_LOGIN
      await this.$store.dispatch('user/logout')
      console.info('logout', isPlaaa, baseLogin)
      if (isPlaaa === '0') {
        this.$router.push('/login')
      } else {
        window.location.href = baseLogin
      }
    },
    changeSys() {
      // const isPlaaa = process.env.VUE_APP_IS_PL
      // const baseIndex = process.env.VUE_APP_INDEX
      // const baseLogin = process.env.VUE_APP_LOGIN
      // console.info('logout', isPlaaa, baseLogin, baseIndex)
      this.$router.push(`/`)
      // if (isPlaaa === '0') {

      // } else {
      //   window.location.href = baseIndex
      // }
    },
    editPassWord() {
      this.pwdUse = true
    },
    pwdUseClose() {
      this.formData.userPwd = ''
      this.formData.nwUserPwd = ''
      this.formData.newUserPwd = ''
      this.formData.qrNewUserPwd = ''
      this.pwdUse = false
    },
    submitPwdFun(formData) {
      this.$refs[formData].validate(valid => {
        if (valid) {
          const data = {
            password: md5(this.formData.nwUserPwd),
            oldPassword: md5(this.formData.userPwd)
          }
          updatePwd(data).then(res => {
            if (res.code === '200') {
              this.$message({
                message: '修改成功！',
                type: 'success'
              })
              this.formData.userPwd = ''
              this.formData.nwUserPwd = ''
              this.formData.newUserPwd = ''
              this.formData.qrNewUserPwd = ''
              this.pwdUse = false
            } else {
              this.$message({
                message: res.msg,
                type: 'error'
              })
            }
          })
        } else {
          return false
        }
      })
    },
    // 个人中心
    handlePersonalCenter() {
      this.$router.push({ name: 'personalCenter' })
    },
    handleClose() {
      this.drawer = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
@import '~@/styles/variables.scss';

.navbar {
    height: 50px;
    overflow: hidden;
    // position: relative;
    background: #fff;
    -webkit-box-shadow: 0 1px 4px rgb(0 21 41 / 8%);
    box-shadow: 0 1px 4px rgb(0 21 41 / 8%);
}

.header {
  //relative
  position: fixed;
  top: 0;
  height: 48px;
  background: #0074CC;
  display: flex;
  justify-content: space-between;
  z-index: 100;
  width: 100%;
}

.system-info {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  line-height: 28px;
}
.user-meta {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.user-info {
  display: flex;
  margin: 0 16px 0 28px;
  font-size: 14px;
  font-weight: 400;
  color: #fff;
  line-height: 22px;
}

.meta-divider {
  height: 100%;
  width: 1px;
  border: 1px solid #fff;
}

.avatar {
  width: 24px;
  height: 24px;
  margin-right: 8px;
  border-radius: 50%;
}

.sidebar-logo {
  width: 36px;
  height: 36px;
  margin-left: 18px;
  margin-right: 8px;
}

.logout {
  margin: 0 24px 0 16px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #fff;
  line-height: 20px;
}

.user-name {
  display: flex;
  align-items: center;
  gap: 8px;
}

.org-name {
  font-size: 13px;
  opacity: 0.9;
  font-weight: 500;
}

.name-separator {
  color: rgba(255, 255, 255, 0.6);
  margin: 0 4px;
}

.user-name-text {
  font-weight: 500;
}

.user-name:hover {
  opacity: 1;
}

.user-name i {
  font-size: 12px;
  margin-left: 6px;
}

img {
  overflow-clip-margin: content-box;
  overflow: clip;
}
// .app-wrapper {
//   @include clearfix;
//   position: relative;
//   height: 100%;
//   width: 100%;

//   &.mobile.openSidebar {
//     position: fixed;
//     top: 0;
//   }
// }

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 48;
  right: 48;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.fixed-header1 {
  position: fixed;
  top: 0;
  right: 0;
  z-index: -1;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}
.el-dropdown-link {
  cursor: pointer;
}
</style>
